/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  messages?: Array<string>;
}

export const ErrorList: React.FC<Props> = ({ messages }) => (
  <>
    {messages &&
      messages.map((message) => (
        <div className="py-1 px-6 my-4 bg-danger-lighten text-danger fs-3" key={message}>
          <FontAwesomeIcon className="mr-3" icon={faBan} />
          {message}
        </div>
      ))}
  </>
);
